import clsx from 'clsx'
import { MouseEventHandler } from 'react'
import { AnyToken } from 'src/common/types/models/Tokens'
import Icon from 'src/common/ui-kit/Icon/Icon'
import TokenIcon from 'src/common/ui-kit/TokenIcon/TokenIcon'
import { displayAmount } from 'src/common/utils/formatters/number'

export interface TokenSelectorItemProps {
  token: AnyToken
  onClick?: (value: AnyToken) => void
  onFavoriteClick?: (value: AnyToken) => void
  onInfoClick?: (value: AnyToken) => void
  className?: string
  favorite?: boolean
  nftGroup?: boolean
}

const TokenSelectorItem: React.FC<TokenSelectorItemProps> = ({
  token,
  favorite,
  onClick,
  onFavoriteClick,
  onInfoClick,
  className,
  nftGroup,
}) => {
  const handleClick = () => {
    onClick?.(token)
  }
  const handleFavoriteClick: MouseEventHandler<HTMLElement> = e => {
    e.preventDefault()
    e.stopPropagation()
    onFavoriteClick?.(token)
    // Temporary behavior until favorite tokens are implemented
  }

  const handleInfoClick: MouseEventHandler<SVGElement> = e => {
    e.preventDefault()
    e.stopPropagation()

    onInfoClick?.(token)
  }

  return (
    <div
      className={clsx(
        'flex justify-between cursor-pointer hover:bg-paper-hover py-1 px-2',
        className
      )}
      onClick={handleClick}
    >
      <div className='flex gap-2 items-center pr-2'>
        <TokenIcon token={token} size={33} />
        <div className='flex flex-col justify-center'>
          <span className='typo-label2 text-main-accent font-medium'>
            {token.symbol}
          </span>
          <span className='typo-label1 text-main-muted'>{token.name}</span>
        </div>
      </div>
      <div className='flex gap-2 items-center' onClick={handleFavoriteClick}>
        <div className='flex flex-col justify-center items-end'>
          {token.balance && token.balance.gt(0) && (
            <span className='typo-label2 text-main-accent font-medium'>
              {displayAmount(token.balance)}
            </span>
          )}
          {token.usdBalance && token.usdBalance.gt(0) && (
            <span className='typo-label1 text-main-muted'>
              ${displayAmount(token.usdBalance)}
            </span>
          )}
        </div>
        <Icon
          onClick={handleInfoClick}
          className='w-5 hover:text-primary transition-colors'
          name='info'
          fill={favorite ? '#8BCA01' : '#ABB2BA'}
        />
      </div>
    </div>
  )
}

export default TokenSelectorItem
